(() => {
  if (window.__bbFavouritesInitialized) return;
  window.__bbFavouritesInitialized = true;

  const STORAGE_KEY = 'buildingbasket:favourites:v1';
  const FAVOURITES_URL = '/pages/favourites';

  function normalizeFavourite(item) {
    if (typeof item === 'string') return { handle: item, variantId: '' };
    if (!item || typeof item !== 'object') return null;

    const handle = String(item.handle || '').trim();
    if (!handle) return null;

    return {
      handle,
      variantId: item.variantId ? String(item.variantId) : '',
    };
  }

  function readFavourites() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];

      const seen = new Set();
      return parsed
        .map(normalizeFavourite)
        .filter((item) => {
          if (!item || seen.has(item.handle)) return false;
          seen.add(item.handle);
          return true;
        });
    } catch (error) {
      return [];
    }
  }

  function writeFavourites(items) {
    const normalized = items.map(normalizeFavourite).filter(Boolean);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
    document.dispatchEvent(new CustomEvent('buildingbasket:favourites-updated', { detail: normalized }));
    return normalized;
  }

  function heartSvg(filled = false) {
    return `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"${filled ? ' fill="currentColor"' : ' fill="none"'} stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
  }

  function currentProductHandle() {
    const match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function currentVariantId() {
    return String(
      document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value ||
        document.querySelector('.product-variant-id')?.value ||
        '',
    );
  }

  function isSaved(handle) {
    return readFavourites().some((item) => item.handle === handle);
  }

  function updateToggleButton(button, saved) {
    if (!button) return;
    button.classList.toggle('is-saved', saved);
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', saved ? 'Remove from favourites' : 'Add to favourites');
    button.querySelector('.bb-favourite-toggle__icon').innerHTML = heartSvg(saved);
    button.querySelector('.bb-favourite-toggle__text').textContent = saved ? 'Saved to favourites' : 'Add to favourites';
  }

  function updateOverlayFavouriteButton(button, saved) {
    if (!button) return;
    button.classList.toggle('is-saved', saved);
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', saved ? 'Remove from favourites' : 'Add to favourites');
    button.querySelector('.bb-image-action__icon').innerHTML = heartSvg(saved);
  }

  function toggleFavourite(handle, variantId = '') {
    if (!handle) return;

    const favourites = readFavourites();
    const existingIndex = favourites.findIndex((item) => item.handle === handle);

    if (existingIndex >= 0) {
      favourites.splice(existingIndex, 1);
    } else {
      favourites.unshift({ handle, variantId: String(variantId || '') });
    }

    writeFavourites(favourites);
  }

  function updateAllFavouriteControls() {
    const productHandle = currentProductHandle();
    document.querySelectorAll('[data-bb-favourite-toggle]').forEach((button) => {
      if (productHandle) updateToggleButton(button, isSaved(productHandle));
    });

    document.querySelectorAll('[data-bb-image-favourite]').forEach((button) => {
      updateOverlayFavouriteButton(button, isSaved(button.dataset.productHandle || ''));
    });
  }

  function injectProductToggle() {
    const handle = currentProductHandle();
    const delivery = document.querySelector('.bb-delivery-reassurance');
    if (!handle || !delivery || document.querySelector('[data-bb-favourite-toggle]')) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'bb-favourite-toggle';
    button.dataset.bbFavouriteToggle = '';
    button.innerHTML = `
      <span class="bb-favourite-toggle__icon" aria-hidden="true"></span>
      <span class="bb-favourite-toggle__text"></span>`;
    updateToggleButton(button, isSaved(handle));

    button.addEventListener('click', () => {
      toggleFavourite(handle, currentVariantId());
    });

    const productInfo = delivery.closest('.product__info-container');
    const shareButton = productInfo?.querySelector('share-button');
    const actions = document.createElement('div');
    actions.className = 'bb-product-actions';
    delivery.insertAdjacentElement('afterend', actions);
    actions.appendChild(button);
    if (shareButton) actions.appendChild(shareButton);
  }

  function createFavouriteOverlay(handle, variantId = '') {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'bb-image-action bb-image-action--favourite';
    button.dataset.bbImageFavourite = '';
    button.dataset.productHandle = handle;
    button.innerHTML = '<span class="bb-image-action__icon" aria-hidden="true"></span>';
    updateOverlayFavouriteButton(button, isSaved(handle));
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggleFavourite(handle, variantId);
    });
    return button;
  }

  function visibleShareControl() {
    const shareButton =
      document.querySelector('.bb-product-actions share-button') ||
      document.querySelector('.product__info-container share-button');
    if (!shareButton) return null;

    return (
      Array.from(shareButton.querySelectorAll('.share-button__button')).find(
        (control) => !control.classList.contains('hidden') && !control.closest('[hidden]'),
      ) || shareButton.querySelector('.share-button__button')
    );
  }

  function injectProductImageActions() {
    const handle = currentProductHandle();
    const mediaWrapper = document.querySelector('.product__media-wrapper');
    if (!handle || !mediaWrapper || mediaWrapper.querySelector('[data-bb-product-image-actions]')) return;

    const actions = document.createElement('div');
    actions.className = 'bb-product-image-actions';
    actions.dataset.bbProductImageActions = '';
    actions.appendChild(createFavouriteOverlay(handle, currentVariantId()));

    const existingShare = visibleShareControl();
    if (existingShare) {
      const shareButton = document.createElement('button');
      shareButton.type = 'button';
      shareButton.className = 'bb-image-action bb-image-action--share';
      shareButton.setAttribute('aria-label', 'Share this product');
      const existingIcon = existingShare.querySelector('.svg-wrapper');
      shareButton.innerHTML = `<span class="bb-image-action__icon" aria-hidden="true">${existingIcon?.innerHTML || ''}</span>`;
      shareButton.addEventListener('click', (event) => {
        event.preventDefault();
        visibleShareControl()?.click();
      });
      actions.appendChild(shareButton);
    }

    mediaWrapper.appendChild(actions);
  }

  function productHandleFromCard(card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';

    try {
      const match = new URL(link.href, window.location.origin).pathname.match(/^\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function injectCardFavouriteOverlays(root) {
    root.querySelectorAll('.card-wrapper.product-card-wrapper').forEach((card) => {
      if (card.querySelector('[data-bb-image-favourite]')) return;
      const handle = productHandleFromCard(card);
      const imageArea = card.querySelector('.card__inner');
      if (!handle || !imageArea) return;

      card.classList.add('bb-recommendation-card');
      imageArea.appendChild(createFavouriteOverlay(handle));
    });
  }

  function initializeCardFavouriteOverlays() {
    document
      .querySelectorAll('[data-bb-related-products], collection-component[data-collection-id]')
      .forEach((root) => {
        if (root.dataset.bbFavouriteObserver === 'true') return;

        root.dataset.bbFavouriteObserver = 'true';
        injectCardFavouriteOverlays(root);
        new MutationObserver(() => injectCardFavouriteOverlays(root)).observe(root, {
          childList: true,
          subtree: true,
        });
      });
  }

  function updateHeaderCount() {
    const count = readFavourites().length;
    const link = document.querySelector('[data-bb-favourites-link]');
    if (!link) return;

    const bubble = link.querySelector('[data-bb-favourites-count]');
    bubble.textContent = String(count);
    bubble.hidden = count === 0;
    link.setAttribute('aria-label', count === 1 ? 'Favourites, 1 saved product' : `Favourites, ${count} saved products`);
  }

  function injectHeaderLink() {
    const cartLink = document.getElementById('cart-icon-bubble') || document.querySelector('.header__icon--cart');
    if (!cartLink || document.querySelector('[data-bb-favourites-link]')) return;

    const link = document.createElement('a');
    link.href = FAVOURITES_URL;
    link.className = 'header__icon link focus-inset bb-header-favourites';
    link.dataset.bbFavouritesLink = '';
    link.innerHTML = `
      <span class="svg-wrapper">${heartSvg(true)}</span>
      <span class="bb-favourites-count-bubble" data-bb-favourites-count hidden></span>
      <span class="visually-hidden">Favourites</span>`;
    cartLink.insertAdjacentElement('beforebegin', link);
    updateHeaderCount();
  }

  window.BuildingBasketFavourites = {
    read: readFavourites,
    write: writeFavourites,
    heartSvg,
  };

  function initialize() {
    injectHeaderLink();
    injectProductToggle();
    injectProductImageActions();
    initializeCardFavouriteOverlays();
  }

  document.addEventListener('buildingbasket:favourites-updated', () => {
    updateHeaderCount();
    updateAllFavouriteControls();
  });

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) {
      updateHeaderCount();
      updateAllFavouriteControls();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
